module.exports = __webpack_public_path__ + "img/octagon.537b8eee.svg";